module.exports = __webpack_public_path__ + "static/heimat-02-0d2f64340f9df1c39ab27b6a610495e2.jpg";